import React from 'react'
import ProductsList from './products/products_list'
import Page from 'ui/page'
import styled from 'styled-components'
import cn from 'classnames'

const DestinationFeatured = styled.div`
  position: relative;
  width: 100%;
  height: 350px;

  .destination-header-caption {
    position: absolute;
    inset: 0; /* sustituye top/left/right/bottom: 0 */
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    h1 {
      color: white;
      font-size: 4.2em;
      font-weight: bold;
      text-shadow: 0 0 20px #000;
      margin: 0;
    }

    .subtitle {
      color: white;
      font-size: 2em;
      font-weight: bold;
      text-shadow: 0 0 20px #000;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const Products = (props) => {
  const { destination, user, mode } = props
  const { headline, banner_url } = destination || {}
  const saleChannel = user?.user_data?.user?.sale_channel

  return (
    <Page {...props} className="mt-0">
      {saleChannel === 'b2c' && headline && banner_url && (
        <DestinationFeatured>
          <div className="destination-header-caption">
            <div>
              <h1>{headline}</h1>
              {false && <div className="subtitle">Subtitle</div>}
            </div>
          </div>
          <img src={banner_url} alt={headline || 'destination banner'} />
        </DestinationFeatured>
      )}

      <div
        className={cn(
          'page',
          mode === 'web'
            ? 'container mt-3 pt-3 mt-lg-4 pt-lg-4'
            : 'container mt-3 mb-3'
        )}
      >
        <ProductsList {...props} />
      </div>
    </Page>
  )
}

export default Products